import store from '@/store';

export function useUser() {
    const user = store.state.user;
    return { user };
}
